export const planetChartData = {
  type: 'pie',
  data: {
    labels: ['Enero', 'Febrero', 'Marzo'],
    datasets: [

      { // one line graph
        label: ['% replicas'],
        data: [15, 24, 21],
        backgroundColor: [
          'rgb(24, 93, 160)',
          'rgb(119, 178, 235)',
          'rgb(144, 192, 239)',
          'rgb(169, 206, 242)',
          'rgb(27, 107, 185)',
          'rgb(31, 122, 210)',
          'rgb(45, 136, 224)',
          'rgb(70, 150, 228)',
          'rgb(95, 164, 231)',

        ],
        borderColor: [
          '#36495d',
          '#36495d',
          '#36495d',
          '#36495d',
          '#36495d',
          '#36495d',
          '#36495d',
          '#36495d',
          '#36495d',
        ],
        borderWidth: 3
      }
    ]
  },
  options: {
    title: {
      display: true,
      text: "Pti´s por tipo de SDI"
    },
    responsive: true,
    // maintainAspectRatio: false,
    lineTension: 1,
    scales: {

    }, tooltips: {
      callbacks: {
        label: function (tooltipItem, data) {
          var dataset = data.datasets[tooltipItem.datasetIndex];
          var total = dataset.data.reduce(function (previousValue, currentValue) {
            return previousValue + currentValue;
          });
          var currentValue = dataset.data[tooltipItem.index];
          var percentage = Math.floor(((currentValue / total) * 100) + 0.5);
          return data.labels[tooltipItem.index] + ": " + currentValue + "   Porcentaje del total de PTI´s: " + percentage + "%";
        }
      }
    }
  }
}

export default planetChartData;